<script>
import { Newsletter } from '@/api/'
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  mounted() {
    if (!this.form.id) {
      this.fetchNewsletter()
    }
  },
  methods: {
    fetchNewsletter() {
      Newsletter.get().then(response => {
        const newsletterData = response.data
        delete newsletterData['id']
        this.$emit('update:form', { ...this.form, ...newsletterData })
      })
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Informacja',
              modelPath: [this, 'form', 'info'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Podsumowanie',
              modelPath: [this, 'form', 'summary'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Tekst podpowiedzi',
              modelPath: [this, 'form', 'input_placeholder'],
              multilingual: true,
              required: true
            }),
            new fields.Input({
              label: 'Treść pierwszej zgody',
              type: 'textarea',
              modelPath: [this, 'form', 'first_agreement'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Treść drugiej zgody',
              type: 'textarea',
              modelPath: [this, 'form', 'second_agreement'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Treść trzeciej zgody',
              type: 'textarea',
              modelPath: [this, 'form', 'third_agreement'],
              multilingual: true
            })
          ]
        }
      ]
    }
  }
}
</script>
